module.exports = __webpack_public_path__ + "static/media/IMG_0971.d7c3afb6.JPG";